<template>
  <main-home-layout>
    <router-view />
  </main-home-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MainHomeLayout from '../layouts/MainHomeLayout'

export default {
  name: 'Vello',

  components: {
    MainHomeLayout,
  },

  computed: {
    ...mapState({
      isAuthenticated: (state) => state.auth.isAuthenticated,
      user: (state) => state.auth.user,
    }),
  },

  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
    }),
  },

  async created() {
    if (!this.isAuthenticated) {
      this.$router.replace({ name: 'auth.login-page' })
    }

    if (!this.user) {
      await this.getAuthenticatedUser()
    }

    if (
      !this.user.date_email_verified &&
      this.user.registration_channel === 'web' &&
      this.$route.name !== 'verification.email-sent' &&
      this.$route.name !== 'verification.code'
    ) {
      this.$router.replace({ name: 'verification.email-sent' })
    }
  },
}
</script>
